import React from "react";
import { SubMenu, MenuItem } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { NavItem } from "./navConfig";

interface SubMenuWrapperProps {
  item: NavItem;
  isActive: boolean;
  hasActiveChild: boolean;
  handleClick: () => void;
}

const SubMenuWrapper = ({
  item,
  isActive,
  hasActiveChild,
  handleClick
}: SubMenuWrapperProps) => {
  const location = useLocation();

  // Renderizar os itens filhos do submenu
  const renderSubItems = (children: NavItem[]) => {
    return children.map((child, idx) => {
      const isChildActive = child.path === location.pathname;

      return (
        <MenuItem
          key={`${child.title}-${idx}`}
          component={<Link to={child.path || "#"} />}
          className={`menuItem submenuItem${isChildActive ? " active" : ""}`}
          icon={
            <span style={{ fontSize: 10, marginRight: 8 }} className={isChildActive ? "active" : ""}>●</span>
          }
          style={{ paddingLeft: 32 }}
          onClick={() => {
            if (!child.path) {
              handleClick();
            }
          }}
        >
          <b className={`menuText${isChildActive ? " active" : ""}`}>{child.title}</b>
        </MenuItem>
      );
    });
  };

  return (
    <div className="submenu-container">
      <SubMenu
        label={<span className={`submenuTitle${hasActiveChild ? " active" : ""}`}>{item.title}</span>}
        icon={<item.icon className={`menuIcon${hasActiveChild ? " active" : ""}`} style={{ color: "#A2A2A2" }} />}
        onClick={(e) => e.stopPropagation()}
      >
        {renderSubItems(item.children || [])}
      </SubMenu>
    </div>
  );
};

export default SubMenuWrapper;
